import React, { useState } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { segmentApi } from '@edulastic/api'
import { captureSentryException } from '@edulastic/common'
import { IconThumbsUp, IconThumbsDown } from '@edulastic/icons'
import { themeColor } from '@edulastic/colors'
import { getAdditionalDataSelector } from '../../../ClassBoard/ducks'
import {
  GROUP_AND_ASSIGN_FEEDBACK_RESPONSE,
  GROUP_AND_ASSIGN_FEEDBACK_SEGMENT_EVENT,
} from './constants'
import { buildGroupAndAssignFeedbackSegmentPayload } from './groupAndAssignUtils'
import {
  FeedbackContainer,
  FeedbackLabel,
  FeedbackButtonsRow,
  FeedbackIconButton,
} from './styled'

const segmentConfig = { attachUserData: true }

const GroupAndAssignFeedback = ({
  group,
  feedbackContext = {},
  includeTestContext = false,
  assignmentAdditionalData,
}) => {
  const [response, setResponse] = useState(null)

  const handleFeedback = (value) => {
    if (response === value) return

    setResponse(value)

    const lcbContext = includeTestContext
      ? {
          testId: assignmentAdditionalData?.testId,
          assignmentId: assignmentAdditionalData?.assignmentId,
          classId: assignmentAdditionalData?.classId,
          termId: assignmentAdditionalData?.termId,
        }
      : {}

    const segmentPayload = buildGroupAndAssignFeedbackSegmentPayload({
      response: value,
      source: feedbackContext.source,
      group,
      reportContext: feedbackContext.reportContext || {},
      lcbContext,
    })

    try {
      segmentApi.genericEventTrack(
        GROUP_AND_ASSIGN_FEEDBACK_SEGMENT_EVENT,
        segmentPayload,
        segmentConfig
      )
    } catch (e) {
      captureSentryException(e, {
        errorMessage:
          'GroupAndAssignFeedback: error tracking feedback segment event',
      })
    }
  }

  return (
    <FeedbackContainer data-cy="groupAndAssignFeedback">
      <FeedbackLabel>Was this helpful</FeedbackLabel>
      <FeedbackButtonsRow>
        <FeedbackIconButton
          type="button"
          data-cy="groupAndAssignFeedbackHelpful"
          aria-label="Mark recommendations as helpful"
          aria-pressed={response === GROUP_AND_ASSIGN_FEEDBACK_RESPONSE.HELPFUL}
          onClick={() =>
            handleFeedback(GROUP_AND_ASSIGN_FEEDBACK_RESPONSE.HELPFUL)
          }
          $active={response === GROUP_AND_ASSIGN_FEEDBACK_RESPONSE.HELPFUL}
          $activeColor={themeColor}
        >
          <IconThumbsUp />
        </FeedbackIconButton>
        <FeedbackIconButton
          type="button"
          data-cy="groupAndAssignFeedbackNotHelpful"
          aria-label="Mark recommendations as not helpful"
          aria-pressed={
            response === GROUP_AND_ASSIGN_FEEDBACK_RESPONSE.NOT_HELPFUL
          }
          onClick={() =>
            handleFeedback(GROUP_AND_ASSIGN_FEEDBACK_RESPONSE.NOT_HELPFUL)
          }
          $active={response === GROUP_AND_ASSIGN_FEEDBACK_RESPONSE.NOT_HELPFUL}
          $activeColor="#CC4100"
        >
          <IconThumbsDown />
        </FeedbackIconButton>
      </FeedbackButtonsRow>
    </FeedbackContainer>
  )
}

export default compose(
  connect((state) => ({
    assignmentAdditionalData: getAdditionalDataSelector(state),
  }))
)(GroupAndAssignFeedback)
